import {
  InvoicePaymentType,
  Language,
  InvoicePaymentPeriod,
  InvoiceStatus,
  NotificationStatus,
  WalletOrderType,
  ActivityTemplateStatus
} from '@link/admin/services/const';

export default {
  common: {
    edit: '編輯',
    search: '搜尋',
    keyword: '關鍵字',
    action: '操作',
    status: '狀態',
    clickToUpload: '上傳',
    uploading: '上傳中',
    copy: '複製',
    delete: '刪除',
    continueConfirm: '是否要繼續？',
    confirmDelete: '是否要刪除{{name}}？',
    account: '帳戶',
    signOut: '登出'
  },
  layouts: {
    sidebar: {
      contracts: '合約管理',
      suppliers: '供應商管理',
      agents: '旅行社管理',
      finance: '付款管理',
      notifications: '通知管理',
      dataExport: '資料匯出',
      activities: '在售商品一覽',
      tools: '工具一覽',
      opsFreeze: 'OPS凍結'
    }
  },
  views: {
    opsFreeze: {
      separatorHint: '可用換行、空格、逗號（, ，）或頓號（、）分隔',
      register: '登錄',
      bookingIdsInput: '輸入預約編號',
      maxBookingCount: '最多{{max}}件',
      exceedMaxCount: '已超過最大件數',
      createSuccess: '登錄成功',
      freezeOperation: '凍結操作',
      unfreezeOperation: '解凍操作',
      reason: '備註',
      reasonPlaceholder: '請輸入操作理由（{{max}}字以內）',
      submitFreeze: '凍結',
      submitUnfreeze: '解凍',
      freezing: '凍結中',
      unfreezing: '解凍中',
      processingHint: '處理完成後將自動下載 CSV',
      freezeSuccess: '凍結已完成',
      unfreezeSuccess: '解凍已完成',
      titleWithCount: '凍結紀錄一覽・{{count}}件',
      newFreeze: '新建凍結',
      batchNo: '編號',
      createdAt: '建立時間',
      status: '狀態',
      targetBookings: '對象預約',
      lastOperation: '最終操作',
      bookingCount: '{{count}}件',
      statusLabel: {
        frozen: '已凍結',
        unfrozen: '已解凍',
        notOperated: '未操作'
      },
      action: {
        freeze: '凍結',
        unfreeze: '解凍'
      }
    },
    activities: {
      pageTitle: '在售商品一覽',
      searchTitle: '商品檢索',
      activityId: '商品ID',
      templateId: 'Template ID',
      activityUrl: '商品URL',
      title: '商品名',
      supplier: '供應商',
      supplierId: '供應商ID',
      supplierName: '供應商名',
      salesStatus: '商品顯示',
      listDisplay: '商品列表顯示',
      category: '類別',
      country: '商品國家・地區',
      confirmationType: '庫存類型',
      inSalePeriod: '銷售期間內',
      unspecified: '不指定',
      salePeriod: '銷售期間',
      netPrice: '批發價（NET）',
      grossPrice: '銷售價（GROSS）',
      unlimited: '無期限',
      downloadCsv: '下載CSV',
      snapshotHint:
        '顯示的資料為前一天的資料（每日深夜更新）。最後更新時間：{{time}}',
      templateStatus: {
        [ActivityTemplateStatus.ActivityTemplateStatusPublished]: '已發佈',
        [ActivityTemplateStatus.ActivityTemplateStatusReviewing]: '發佈申請中',
        [ActivityTemplateStatus.ActivityTemplateStatusApproved]: '發佈已確認',
        [ActivityTemplateStatus.ActivityTemplateStatusDraft]: '草稿'
      }
    },
    dataExport: {
      period: '期間',
      dataExport: '資料匯出',
      bookingData: '預訂資料',
      download: '下載檔案',
      monthLabel: '{{year}}年{{month}}月',
      downloadHint: '點擊按鈕後，在自動下載開始前請勿關閉頁面。',
      currentMonthHint: '當月資料將在準備完成後傳送至 Slack 頻道，請稍候。',
      slackNotice: '資料準備完成後將傳送至 Slack 頻道',
      notGenerated: '所選期間的資料尚未產生'
    },
    dashboard: {
      title: '儀表板'
    },
    whitelist: {
      title: '白名單',
      add: '新增到白名單',
      alertTitle: '新增旅行社'
    },
    activityPublish: {
      title: '商品發布管理',
      alertTitle: '商品發布確認'
    },
    suppliersList: {
      title: '供應商列表',
      supplierCustomId: '供應商 ID',
      originalName: '供應商名',
      englishName: '供應商（英文名）',
      country: '國家/地區',
      action: '操作'
    },
    agentsList: {
      title: '旅行社列表',
      originalName: '旅行社名稱',
      englishName: '旅行社名稱（英文）',
      paymentType: '付款方式',
      country: '國家/地區'
    },
    orgList: {
      title: '群組管理',
      searchLabel: '旅行社'
    },
    agentAccountList: {
      title: '帳戶管理',
      otaLabel: '旅行社',
      otaOrgLabel: '所屬群組'
    },
    apiKeyList: {
      title: 'api-key',
      otaId: '旅行社',
      otaOrgId: '組織',
      createTime: '建立日期',
      addConfirmTitle: '確認新增 API Key',
      deleteConfirmTitle: '確認刪除 API Key'
    },
    agentsCharge: {
      title: '餘額儲值'
    },
    financeTransactions: {
      title: '結算報表',
      transactionStatus: '結算狀態',
      keyword: 'ID搜尋',
      difference: '交易類型',
      differenceOTA: '旅行社',
      differenceSupplier: '供應商',
      dueDate: '帳單發行日',
      invoiceNumber: '帳單 ID',
      date: '請款週期',
      fromDate: '{{fromDate}}~{{toDate}}',
      currency: '貨幣單位',
      amount: '付款金額合計',
      preAmount: '調整前的請款金額',
      lastAmount: '最終合計金額',
      adjustedAmount: '調整金額',
      finalAmount: '最終合計金額',
      adjust: '調整',
      showjust: '顯示',
      paid: '付款完成',
      change: '已付款',
      invoice: '帳單明細',
      jaInvoice: '支付通知書(日文)',
      jaInvoiceDetails: '明細書(日文)',
      enInvoice: '支付通知書(英文)',
      enInvoiceDetails: '明細書(英文)',
      attachment: '附件',
      changeTitle: '是否已付款？',
      changeTitlePay: '是否已完成付款？',
      changeMessage: '交易狀態將變更為「已付款」',
      changeMessagePay: '交易狀態將變更為「入款完成」',
      depositTitle: '交易資訊',
      depositDate: '付款日期',
      depositAmount: '付款金額',
      payDate: '支付日期',
      payAmount: '出金金額',
      remark: '備註',
      confirmButton: '已入金',
      invoiceList: '帳單列表',
      payNoticeList: '支付通知書列表'
    },
    financeCharge: {
      title: '餘額管理',
      agentId: '旅行社 ID',
      agentName: '旅行社名',
      country: '國家/地區',
      method: '支付方式',
      chargeCycle: '結算週期',
      status: '待確認／儲值紀錄',
      includeDeletedAgents: '包含已刪除的旅行社',
      bulkDownload: '批次下載',
      downloadTitle: '下載餘額紀錄',
      downloadMessage: '請選擇開始時間與結束時間',
      startTime: '開始時間',
      endTime: '結束時間'
    },
    financeChargeHistory: {
      title: '儲值紀錄',
      date: '日期時間',
      amount: '金額',
      invoice: '預付請款書',
      status: '交易狀態',
      note: '備註',
      code: '確認碼',
      change: '操作',
      invoiceStatusConfirmed: '到帳確認',
      changeTitle: '已確認到帳',
      changeConfirm: '將向該帳戶執行儲值。',
      accountBalance: '帳戶餘額',
      accountBuffer: '帳戶緩衝金',
      deposit: '付款',
      changeAmount: '變更金額',
      walletTitle: '帳戶資訊',
      amountType: '付款方式'
    },
    webHook: {
      title: 'WebHook設定',
      otaLabel: '旅行社',
      endpoint: 'End point',
      secretToken: 'Secret token'
    },
    notificationsList: {
      title: '手動通知',
      notification: '通知',
      resultCount: '搜尋結果：{{count}}筆',
      notificationTitle: '通知名稱',
      notificationContent: '通知內容',
      sendTime: '發送時間',
      sendStatus: '發送狀態',
      deleteConfirmTitle: '是否要刪除此通知？',
      confirmDelete: '刪除',
      deleteWarning: '一旦刪除後，無法恢復此通知。',
      addNew: '新增通知',
      send: '發送',
      confirmSend: '發送',
      sendConfirmTitle: '是否要發送此通知？',
      sendSuccess: '通知已發送',
      sendFailed: '通知發送失敗',
      sendWarning: '發送後無法取消此通知。',
      resend: '重新發送',
      pin: '置頂',
      unpin: '取消置頂',
      pinConfirmTitle: '是否要將此通知置頂？',
      unpinConfirmTitle: '是否要取消此通知的置頂？',
      confirmPin: '設為置頂',
      confirmUnpin: '解除',
      pinSuccess: '已置頂',
      pinFailed: '置頂失敗',
      unpinSuccess: '已取消置頂',
      unpinFailed: '取消置頂失敗',
      failedEmailsTitle: '發送失敗詳情',
      failedEmailTo: '發送對象',
      failedEmailReason: '失敗原因',
      failedEmailsLoadError: '取得失敗資訊失敗',
      noFailedEmails: '沒有失敗資料'
    },
    notificationDetail: {
      addTitle: '新增通知',
      editTitle: '編輯通知',
      notificationTitle: '通知名稱',
      notificationContent: '通知內容',
      relatedProducts: '相關商品',
      productAll: '不相關',
      productSpecified: '指定特定商品',
      productIdsHint: '輸入商品ID（以半形逗號分隔）',
      sendTiming: '發送時間',
      sendNow: '立即發送',
      scheduled: '設定時間發送',
      scheduledTime: '預訂日期時間',
      editLanguages: '編輯語言',
      editLanguagesRequired: '請選擇編輯語言',
      langTitle: '標題',
      langContent: '內文',
      targetScope: '適用範圍',
      targetAll: '全部',
      targetTypeEmail: '發送至登入電子郵件地址',
      targetTypeRole: '選擇權限後發送',
      targetEmailDomain: '對象網域',
      targetEmailDomainAdmin: 'Admin',
      targetEmailDomainOta: 'OTA',
      targetEmailDomainSupplier: 'SUP',
      toEmails: '發送對象電子郵件地址',
      toEmailsHint: '請輸入電子郵件地址（以半形逗號「,」分隔）',
      roleOta: 'OTA',
      roleSupplier: 'SUP',
      roleAdmin: 'Admin',
      saveAsDraft: '暫存',
      send: '發送',
      savedAsDraft: '已暫存',
      saveAsDraftFailed: '暫存失敗',
      sendSuccess: '通知已發送',
      sendFailed: '通知發送失敗'
    }
  },
  const: {
    invoicePaymentType: {
      [InvoicePaymentType.PostBankTransfer]: '後付（銀行轉帳）',
      [InvoicePaymentType.PreLinkpay]: '線上付款（預付款）',
      [InvoicePaymentType.PostLinkpay]: '後付（LinkPay）',
      [InvoicePaymentType.PreCharge]: '銀行轉帳（預付款）'
    },
    invoicePaymentPeriod: {
      [InvoicePaymentPeriod.Monthly]: '月',
      [InvoicePaymentPeriod.Weekly]: '週',
      [InvoicePaymentPeriod.HalfMonthly]: '雙週'
    },
    invoiceStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '待付款',
      [InvoiceStatus.InvoiceStatusConfirmed]: '付款完成',
      [InvoiceStatus.InvoiceStatusPaid]: '付款確認中',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    },
    walletOrderType: {
      [WalletOrderType.TypeBalance]: '餘額儲值',
      [WalletOrderType.TypeBuffer]: '緩衝金儲值'
    },
    invoicePayStatus: {
      [InvoiceStatus.InvoiceStatusPending]: '付款準備中',
      [InvoiceStatus.InvoiceStatusConfirmed]: '付款完成',
      [InvoiceStatus.InvoiceStatusPaid]: '待入帳確認',
      [InvoiceStatus.InvoiceStatusCancelled]: '已取消'
    },
    notificationStatus: {
      [NotificationStatus.NotificationStatusSent]: '已發送',
      [NotificationStatus.NotificationStatusTotalFailed]: '發送失敗',
      [NotificationStatus.NotificationStatusPartialFailed]: '部分發送失敗',
      [NotificationStatus.NotificationStatusSending]: '發送中',
      [NotificationStatus.NotificationStatusTempSaved]: '暫存',
      [NotificationStatus.NotificationStatusScheduled]: '待發送'
    },
    notificationLanguage: {
      [Language.English]: '英語',
      [Language.Japanese]: '日語',
      [Language.Korean]: '韓語',
      [Language.SimplifiedChinese]: '中文(簡體)',
      [Language.TraditionalChinese]: '中文(繁體)'
    }
  }
};
